import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    {
      path: "/",
      label: "Home",
      icon: (isActive) => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            fill={isActive ? "#ffffff" : "none"}
          />
          <path
            d="M9 22V12H15V22"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            fill={isActive ? "#ffffff" : "none"}
          />
        </svg>
      ),
    },
    {
      path: "/invest",
      label: "Invest",
      icon: (isActive) => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 3V21H21"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 12L10 9L13 12L17 8"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      path: "/market",
      label: "Market",
      icon: (isActive) => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 3V21H21"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 9L12 6L15 9L18 6"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 15L12 12L15 15L18 12"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      path: "/account",
      label: "Account",
      icon: (isActive) => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="7"
            r="4"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            fill={isActive ? "#ffffff" : "none"}
          />
        </svg>
      ),
    },
    {
      path: "/test",
      label: "Test",
      icon: (isActive) => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 12L11 14L15 10"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke={isActive ? "#ffffff" : "#ffffff"}
            strokeWidth={isActive ? "2" : "1.5"}
            fill={isActive ? "#ffffff" : "none"}
          />
        </svg>
      ),
    },
  ];

  return (
    <nav className="nav-bar-vertical">
      <div className="logo-box-placeholder">
        <div
          style={{
            fontSize: "2.5rem",
            fontWeight: "900",
            color: "#ffffff",
            letterSpacing: "2px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          X
        </div>
      </div>
      <div className="nav-items-vertical">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item-vertical ${isActive ? "active" : ""}`}
            >
              <div style={{ marginBottom: "4px" }}>{item.icon(isActive)}</div>
              <div style={{ fontSize: "0.8rem" }}>{item.label}</div>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
